export default {
  edit: '/setting_password',
};
